<template>
  <div v-bind="$attrs" qaid="customization-bike-image" class="customization-bike-image-container w-full">
    <pdl-image
      v-if="customizationImageLayers"
      :custom-key="imageKey"
      custom-id="customization-bike-image"
      is-zoom
      :image-layers="customizationImageLayers"
      aspect-ratio="16:9"
      alt=""
    />
    <pdl-skeleton v-else height="35vh" />
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import {PdlSkeleton} from '@pedal/pdl-skeleton';
import {PdlImage} from '@pedal/pdl-image';

export default {
  components: {
    PdlSkeleton,
    PdlImage,
  },
  computed: {
    ...mapState('productDetails', ['isCustomizationMode']),
    ...mapGetters('bikeCustomization', ['customizationImageLayers']),

    imageKey() {
      return `${JSON.stringify(this.customizationImageLayers)}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.customization-bike-image-container {
  :deep(.button.button--icon-only) {
    display: none;

    @media (screen(md)) {
      display: flex;
    }
  }

  :deep(#customization-bike-image) {
    // note if aspect-ratio/max-height changes, we'll also need to update --customization-img-top on ColorSelectorDrawer.vue and CustomizationGroupSelector.vue
    max-height: 35vh;

    @media (screen(lg)) {
      max-height: 100vh;
    }

    img {
      height: auto;
    }

    .assetWrapper {
      max-height: 35vh;

      @media (screen(lg)) {
        max-height: 100vh;
      }
    }

    [class^='css-']:not(img) {
      max-height: 35vh;

      @media (screen(lg)) {
        max-height: 100vh;
      }
    }
  }
}
</style>
